import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  titleTypography: {
    textAlign: 'center',
  },
  unpairedPlayersPanelWrapper: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 3,
  },
  filterPlayersWrapper: {
    padding: 10,
  },
  filterPlayersInputAdornment: {
    padding: 0,
  },
  panelWrapper: {
    backgroundColor: theme.palette.grey[400],
    borderRadius: 3,
    padding: `10px 15px`,
  },
  listItem: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 3,
    marginBottom: 2,
  },
  unpairedListItemsWrapper: {
    paddingLeft: 15,
    paddingRight: 15,
  },
  unpairedListItemNoBorder: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  unpairedListItem: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    paddingLeft: 0,
    paddingRight: 0,
  },
  unpairedListItemSecondaryAction: {
    right: 0,
  },
  closeIcon: {
    marginTop: 5,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  emptyListWrapper: {
    padding: 20,
  },
  emptyListTextWrapperWithoutPadding: {
    backgroundColor: theme.palette.grey[400],
    textAlign: 'center',
  },
  emptyListTextWrapper: {
    backgroundColor: theme.palette.grey[400],
    padding: 20,
    textAlign: 'center',
  },
  createDoublesTitle: {
    position: 'relative',
  },
  showAllEntriesToggle: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));
